module.exports = __webpack_public_path__ + "media/handshake-message/handshake-message2-mobile-33ea61e2.png";